import {isWebCitationsEvent,type CodexNotification,type WebCitationsEvent} from '@reados/contracts';

export interface WebCitationHistory {ownerThreadId:string;events:WebCitationsEvent[]}

/** Durable metadata lives outside the transient native event window. Native
 * IDs remain unchanged when inherited by a fork; the Web owner scopes access. */
export function mergeWebCitationHistory(current:WebCitationHistory|null,incoming:readonly CodexNotification[],ownerThreadId:string):WebCitationHistory {
  const merged=new Map<string,WebCitationsEvent>();
  const previous=current?.ownerThreadId===ownerThreadId?current.events:[];
  for(const event of [...previous,...incoming]){
    if(!isWebCitationsEvent(event)||event.params.ownerThreadId!==ownerThreadId)continue;
    const p=event.params,key=JSON.stringify([p.threadId,p.turnId,p.itemId]),prior=merged.get(key);
    if(!prior||p.revision>prior.params.revision)merged.set(key,event);
  }
  return {ownerThreadId,events:[...merged.values()]};
}

export function webCitationEventsForThread(history:WebCitationHistory|null,ownerThreadId:string|null):WebCitationsEvent[] {
  return history?.ownerThreadId===ownerThreadId?history.events:[];
}
